<template>
  <span class="documents-tooltip-wrapper">
    <template v-if="isSpecialSource">
      <ul class="documents-list">
        <li
          v-for="(doc, i) in value"
          :key="i"
          class="documents-link"
          @click="clickHandlerDocument(doc)"
        >
          {{ doc.name }}
        </li>
      </ul>
    </template>
    <template v-else>
      {{ allDocuments }}
    </template>
  </span>
</template>

<script>
import Vue from "vue";
import { openDocument, isSupportedSource } from "@/utils/documentHandler";

export default Vue.extend({
  name: "DocumentsTooltip",

  props: {
    value: {
      type: Array,
      default: () => [],
    },
    row: Object,
  },

  computed: {
    allDocuments() {
      return this.value?.map((doc) => doc.name).join("  ") || "";
    },

    isSpecialSource() {
      return isSupportedSource(this.row?.proposalSource);
    },
  },

  methods: {
    async clickHandlerDocument(doc) {
      if (!doc || !this.isSpecialSource) return;

      try {
        await openDocument(doc, this.row?.proposalSource);
      } catch (error) {
        console.error("Failed to open document:", error);
        this.$toast?.error("Не удалось открыть документ");
      }
    },
  },
});
</script>

<style scoped lang="less">
.documents-tooltip-wrapper {
  display: block;

  .documents-list {
    padding: 0;
    margin: 0;
    list-style: none;

    li.documents-link {
      text-decoration: underline;
      cursor: pointer;
      margin: 2px 0;

      &:hover {
        text-decoration: none;
      }
    }
  }
}
</style>
